// Archivo de versión que se actualiza automáticamente en cada build
// Última actualización: 27/4/2026 10:29:25

export const FRONTEND_VERSION = "2026-04-27T15:29:25.871Z";
export const BUILD_DATE = "27/4/2026";
export const BUILD_TIME = "10:29:25";
export const BUILD_TIMESTAMP = 1777303765871;

// Función para obtener la versión completa
export const getVersionInfo = () => ({
  version: FRONTEND_VERSION,
  buildDate: BUILD_DATE,
  buildTime: BUILD_TIME,
  timestamp: BUILD_TIMESTAMP,
  lastUpdate: "27/4/2026 10:29:25"
});

// Función para comparar versiones
export const compareVersions = (version1, version2) => {
  if (!version1 || !version2) return false;
  return version1 === version2;
};

// Función para obtener información de build
export const getBuildInfo = () => ({
  version: FRONTEND_VERSION,
  buildDate: BUILD_DATE,
  buildTime: BUILD_TIME,
  timestamp: BUILD_TIMESTAMP,
  nodeVersion: process.version,
  buildEnvironment: process.env.NODE_ENV || 'development'
});
